module.exports = __webpack_public_path__ + "assets/other.dd635097.png";


//////////////////
// WEBPACK FOOTER
// ./client/assets/images/logos/other.png
// module id = 273
// module chunks = 1